import api from './baseService';

const WAF_HTML = '<html><head><title>Request Rejected</title></head><body>The requested URL was rejected. Please consult with your administrator.<br><br>Your support ID: 6ed4a346-10b5-40ef-9ac1-c197f6a6fbe3<br><br><a href=\'javascript:history.back();\'>[Go Back]</a></body></html>';

const UNKNOWN_HTML = '<html><head><title>Request Rejected</title></head><body>The requested URL was rejected. Please consult with your administrator.<br><br><a href=\'javascript:history.back();\'>[Go Back]</a></body></html>';

/**
 * Simulates a WAF (Web Application Firewall) rejection on a POST to the product assets endpoint.
 * The WAF returns a 200 with an HTML body. In production, axios's built-in transformResponse
 * tries to JSON.parse() that HTML, fails, and throws a SyntaxError — which is what the catch
 * block in the caller sees. We replicate that exact behavior here.
 */
export const postWAFErrorAsset = (payload) =>
	api().post('/pdb/products/1/assets', payload, {
		adapter: (config) => {
			const response = {
				data: WAF_HTML,
				status: 200,
				statusText: 'OK',
				headers: { 'content-type': 'text/html; charset=utf-8' },
				config,
			};
			// Mimic axios transformResponse: JSON.parse(htmlString) throws SyntaxError
			const error = new SyntaxError(
				'Unexpected token \'<\', "' + WAF_HTML.substring(0, 15) + '..." is not valid JSON'
			);
			error.response = response;
			return Promise.reject(error);
		},
	});

/**
 * Simulates an unknown HTML parse error (no WAF support ID) on a POST to the product assets endpoint.
 * Same as postWAFErrorAsset but the response body has no support ID, so extractWAFSupportId returns nothing.
 */
export const postParseErrorAsset = (payload) =>
	api().post('/pdb/products/1/assets', payload, {
		adapter: (config) => {
			const response = {
				data: UNKNOWN_HTML,
				status: 200,
				statusText: 'OK',
				headers: { 'content-type': 'text/html; charset=utf-8' },
				config,
			};
			// Mimic axios transformResponse: JSON.parse(htmlString) throws SyntaxError
			const error = new SyntaxError(
				'Unexpected token \'<\', "' + UNKNOWN_HTML.substring(0, 15) + '..." is not valid JSON'
			);
			error.response = response;
			return Promise.reject(error);
		},
	});

